const src = import.meta.ROLLUP_FILE_URL_TX5a1iViCylaCWPFSCQG2w;
export default {
  src,
  srcSet: src + " " + 1332 + "w",
  width: 1332,
  height: 890,
};